import React from 'react';

export const BristolIcon = ({ type }: { type: number }) => {
  if (type === 1) {
    return (
      <svg width="60" height="60" viewBox="0 0 60 60" fill="none">
        <circle cx="15" cy="25" r="6" fill="#8B4513"/>
        <circle cx="28" cy="28" r="5" fill="#8B4513"/>
        <circle cx="40" cy="26" r="6" fill="#8B4513"/>
        <circle cx="22" cy="38" r="5" fill="#8B4513"/>
        <circle cx="35" cy="40" r="5" fill="#8B4513"/>
      </svg>
    );
  }

  if (type === 2) {
    return (
      <svg width="60" height="60" viewBox="0 0 60 60" fill="none">
        <ellipse cx="30" cy="30" rx="25" ry="12" fill="#8B4513"/>
        <path d="M8 30 Q15 25, 22 30 T36 30 T52 30" stroke="#654321" strokeWidth="2" fill="none"/>
        <path d="M8 32 Q15 37, 22 32 T36 32 T52 32" stroke="#654321" strokeWidth="2" fill="none"/>
      </svg>
    );
  }

  if (type === 3) {
    return (
      <svg width="60" height="60" viewBox="0 0 60 60" fill="none">
        <rect x="10" y="24" width="40" height="12" rx="6" fill="#8B4513"/>
        <line x1="22" y1="24" x2="22" y2="36" stroke="#654321" strokeWidth="2"/>
        <line x1="32" y1="24" x2="32" y2="36" stroke="#654321" strokeWidth="2"/>
        <line x1="42" y1="24" x2="42" y2="36" stroke="#654321" strokeWidth="2"/>
      </svg>
    );
  }

  if (type === 4) {
    return (
      <svg width="60" height="60" viewBox="0 0 60 60" fill="none">
        <rect x="10" y="24" width="40" height="12" rx="6" fill="#A0522D"/>
        <ellipse cx="30" cy="27" rx="18" ry="2" fill="#8B4513" opacity="0.3"/>
      </svg>
    );
  }

  if (type === 5) {
    return (
      <svg width="60" height="60" viewBox="0 0 60 60" fill="none">
        <ellipse cx="15" cy="30" rx="8" ry="6" fill="#A0522D"/>
        <ellipse cx="30" cy="30" rx="8" ry="6" fill="#A0522D"/>
        <ellipse cx="45" cy="30" rx="8" ry="6" fill="#A0522D"/>
      </svg>
    );
  }

  if (type === 6) {
    return (
      <svg width="60" height="60" viewBox="0 0 60 60" fill="none">
        <path
          d="M10 30 Q15 25, 20 30 Q25 35, 30 30 Q35 25, 40 30 Q45 35, 50 30"
          stroke="#A0522D"
          strokeWidth="8"
          strokeLinecap="round"
          fill="none"
        />
        <circle cx="15" cy="30" r="4" fill="#A0522D" opacity="0.6"/>
        <circle cx="25" cy="32" r="3" fill="#A0522D" opacity="0.6"/>
        <circle cx="35" cy="28" r="3" fill="#A0522D" opacity="0.6"/>
        <circle cx="45" cy="32" r="4" fill="#A0522D" opacity="0.6"/>
      </svg>
    );
  }

  if (type === 7) {
    return (
      <svg width="60" height="60" viewBox="0 0 60 60" fill="none">
        <ellipse cx="30" cy="30" rx="20" ry="8" fill="#CD853F" opacity="0.7"/>
        <ellipse cx="25" cy="28" rx="8" ry="4" fill="#CD853F" opacity="0.5"/>
        <ellipse cx="35" cy="32" rx="10" ry="5" fill="#CD853F" opacity="0.5"/>
        <path
          d="M20 30 Q25 28, 30 30 Q35 32, 40 30"
          stroke="#A0522D"
          strokeWidth="1"
          fill="none"
          opacity="0.3"
        />
      </svg>
    );
  }

  return null;
};
